var React = require('react');

function IconMinus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Minus icon"),React.createElement("desc",{"key":1},"Minus icon"),React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(1 1)","key":2},React.createElement("path",{"d":"M20.571 16H11.43"}))]);
}

IconMinus.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","role":"img"};

module.exports = IconMinus;

IconMinus.default = IconMinus;
